<template>
    <transition name="slide-fade-enter" >
        <div style="min-height: 70vh;">
            <div class="uk-padding" >
                <div class="uk-container uk-container-small">
                    <h1 class="uk-heading-line uk-text-center">Private Businesses and Individuals</h1>
                    <p>
                        At FINCOR we understand the challenges of running your business. We
                        know that it can be difficult meeting the demands of your customers while
                        staying on top of the paperwork. When you work with us, we take care of
                        your books, so you can get back to the job of running your business,
                        generating profits, and making your customers happy!
                    </p>
                    <ul class="uk-list uk-list-bullet">
                        Each month or quarter we&#39;ll do the following:
                        <li>Reconcile your bank account;</li>
                        <li>Generate an income statement;</li>
                        <li>Clean up your general ledger; and</li>
                        <li>Update you on how things are going, and point out any
                            areas for concern.</li>
                    </ul>
                    <p>
                        These services will provide you with a solid insight on how your business is
                        doing, and relieve some of the stress of trying to keep it all in your head.
                        You can customize the package of services you receive by adding bill
                        processing, payroll, billing, or any of our other services.
                    </p>

                </div>


            </div>
            <div class="uk-padding uk-background-muted uk-margin-remove-bottom">
                <div class="uk-container ">
                    <h3 class="uk-heading-bullet specHeading uk-text-bold">Businesses and clients currently served:</h3>
                    <div class="uk-child-width-1-4@m" uk-grid>
                        <div>
                            <div>
                                <div class="uk-card uk-card-default">
                                    <div class="uk-card-media-top">
                                        <img src="../assets/pbi3.png" alt="">
                                    </div>
                                    <div class="uk-card-body" style="padding: 10px;">
                                        <h5 class="specHeading uk-text-bold">Retail and consumer products</h5>

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div>
                            <div>
                                <div class="uk-card uk-card-default">
                                    <div class="uk-card-media-top">
                                        <img src="../assets/pbi1.png" alt="">
                                    </div>
                                    <div class="uk-card-body" style="padding: 10px;">
                                        <h5 class="specHeading uk-text-bold">Restaurants</h5>

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div>
                            <div>
                                <div class="uk-card uk-card-default">
                                    <div class="uk-card-media-top">
                                        <img src="../assets/pbi2.png" alt="">
                                    </div>
                                    <div class="uk-card-body" style="padding: 10px;">
                                        <h5 class="specHeading uk-text-bold">Real Estate & Construction Developers</h5>

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div>
                            <div>
                                <div class="uk-card uk-card-default">
                                    <div class="uk-card-media-top">
                                        <img src="../assets/pbi4.png" alt="">
                                    </div>
                                    <div class="uk-card-body" style="padding: 10px;">
                                        <h5 class="specHeading uk-text-bold">High-Net Worth Individuals</h5>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
      name: "pbi",
      metaInfo: {
        title: ' Private Business & Individual Services',
        meta: [{
          content: 'We offer services to private businesses and individuals such as:  reconciling your bank account, generating an income statement, cleaning up your general ledger and updating you on how things are going, and pointing out any areas for concern.'
        }]
      }
    }
</script>

<style scoped>

</style>